import endpoint from "../../config/endpoints";

export const EnquiryPurposeJson = {
    showSaveNextBtn: true,
    formPath: "/enquiry-purpose-form",
    apiBaseURL: endpoint.enquiryPurpose,
    changeExcel: endpoint.exportData,
    screenTitle: "Enquiry Purpose",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Enquiry Purpose",
    showExcelDownload: true,
    excelFileName: "Enquiry Purpose",
    formPathView: "/enquiry-purpose-view",
    isActiveURL: endpoint.enquiryPurpose + "/update-is-active",
    noteValue: 'Enquiry Purpose',
    tableColumnsToFilter: [
        {
            columnDisplayName: "Enquiry Purpose Name",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Enquiry Purpose Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "name",
            isMandatory: true,
            uniqueValidation: true,
        },
    ],
};